import { render } from "./CtaBlock.vue?vue&type=template&id=dcb8b184"
import script from "./CtaBlock.vue?vue&type=script&lang=js"
export * from "./CtaBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__